var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showType == 'properties')?_c('div',[_c('eoc-vitals-v1-properties',{attrs:{"formId":_vm.formId}})],1):_c('b-form-group',{staticStyle:{"font-size":"14px"},style:(_vm.properties.style),attrs:{"description":_vm.superComputeFormSubmitterValue({
        elementId: this.id,
        property: 'description',
        value: _vm.properties.description,
        defaultValue: '',
        form: this.form
      }),"label":_vm.superComputeFormSubmitterValue({
        elementId: this.id,
        property: 'label',
        value: _vm.properties.label,
        defaultValue: '',
        form: this.form
      })}},[_c('fb-table-v1',{attrs:{"showType":_vm.showType,"properties":_vm.tableProperties,"id":_vm.id,"form":_vm.form}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }